// NotificationBanner.tsx
import React, { useEffect } from 'react'
import { CheckCircle, AlertCircle, Info, AlertTriangle, X } from 'lucide-react'

interface Props {
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
  show: boolean
  onClose: () => void
}

const icons = {
  success: CheckCircle,
  error: AlertCircle,
  info: Info,
  warning: AlertTriangle,
}

const colors = {
  success: 'from-green-500/20 to-emerald-500/20 border-green-500/40 text-green-300',
  error: 'from-red-500/20 to-rose-500/20 border-red-500/40 text-red-300',
  info: 'from-blue-500/20 to-cyan-500/20 border-blue-500/40 text-blue-300',
  warning: 'from-yellow-500/20 to-orange-500/20 border-yellow-500/40 text-yellow-300',
}

const NotificationBanner: React.FC<Props> = ({ message, type, show, onClose }) => {
  const Icon = icons[type]

  if (!show || !message) return null

  return (
    <div
      className="fixed top-6 right-6 z-[100] max-w-sm animate-fade-in-up"
      role="alert"
    >
      <div
        className={`flex items-start gap-3 p-4 rounded-2xl border bg-gradient-to-r backdrop-blur-xl shadow-2xl ${colors[type]}`}
      >
        <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
        <p className="text-sm font-medium flex-1">{message}</p>
        <button
          onClick={onClose}
          className="flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}

export default NotificationBanner
